import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-[#E5E5E3] bg-[#FAFAF7]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-10 grid sm:grid-cols-2 gap-6 sm:items-end">
        <div>
          <Link to="/" className="inline-flex items-center" aria-label="Hoomanz — Home">
            <img src="/brand/hoomanz-logo.png" alt="Hoomanz" className="h-8 w-auto select-none"/>
          </Link>
          <p className="text-sm text-[#4A4A4A] mt-2">Humans helping humans. Make a living doing what you love.</p>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 sm:justify-end text-sm text-[#4A4A4A]" aria-label="Footer">
          <Link to="/discover" className="hover:text-[#0A0A0A]" data-testid="footer-discover">Discover</Link>
          <Link to="/jobs" className="hover:text-[#0A0A0A]" data-testid="footer-jobs">Jobs</Link>
          <Link to="/market" className="hover:text-[#0A0A0A]" data-testid="footer-market">For Sale</Link>
          <Link to="/rentals" className="hover:text-[#0A0A0A]" data-testid="footer-rentals">Rentals</Link>
          <Link to="/privacy" className="hover:text-[#0A0A0A]" data-testid="footer-privacy">Privacy</Link>
          <a href="mailto:hello@hoomanz.co" className="hover:text-[#0A0A0A]" data-testid="footer-contact">Contact</a>
        </nav>
      </div>
      <div className="border-t border-[#E5E5E3]/60">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-4 text-xs text-[#8A8A8A] flex flex-wrap items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Hoomanz · All rights reserved.</span>
          <span>Built for the independent economy.</span>
        </div>
      </div>
    </footer>
  );
}
